import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import { Root, Input } from './SwitchBase.styles';
/**
 * @ignore - internal component.
 */

var SwitchBase = React.forwardRef(function (props, ref) {
  var autoFocus = props.autoFocus,
      checked = props.checked,
      checkedIcon = props.checkedIcon,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabled = props.disabled,
      icon = props.icon,
      id = props.id,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onMouseDown = props.onMouseDown,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      inputRef = props.inputRef,
      otherProps = __rest(props, ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "icon", "id", "name", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "required", "tabIndex", "type", "value", "inputRef"]);

  var handleInputChange = useCallback(function (event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event, event.target.checked);
  }, [onChange]);
  return _jsxs(Root, __assign({
    className: classnames(className, {
      disabled: disabled
    }),
    ref: ref
  }, otherProps, {
    children: [_jsx(Input, {
      autoFocus: autoFocus,
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onChange: handleInputChange,
      onFocus: onFocus,
      onBlur: onBlur,
      readOnly: readOnly,
      required: required,
      tabIndex: tabIndex,
      type: type,
      value: value,
      ref: inputRef
    }), checked ? checkedIcon : icon]
  }));
});
export default SwitchBase;